import { useSelector } from "react-redux";
import { Dot, Phone } from "lucide-react";
import { UNVISITED_SITE_COLUMNS } from "../../utils/siteTables.config";
import ArrowSorting from "../../../../components/common/ArrowSorting";
import {formatDate} from "../../../../functions/dateTime/formatDate"

export const SiteTable = () => {
  const data = useSelector((state) => state.data.data);
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden mt-2">
      <div className="h-[calc(100vh-18em)] max-lg:h-[calc(100vh-17em)] max-md:h-[calc(100vh-16em)] overflow-auto">
        <table className="w-full border border-b-0">
          {/* Header */}
          <thead className="bg-[#f4f6fc] text-blue-1 uppercase text-[14px] max-lg:text-[11px] sticky top-0 2xs:max-md:top-0 z-99">
            <tr>
              {UNVISITED_SITE_COLUMNS.map((c) => (
                <th key={c.title} className="text-left px-4 py-3">
                  <span className="flex items-center">
                    {c.title}{" "}
                    {c.sortArrow && data.length > 1 && (
                      <ArrowSorting
                        sortBy={c.sortBy}
                        address={c.address}
                        arrowColor="#3a4faa"
                      />
                    )}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          {/* Body */}
          <tbody className="text-[14px] max-lg:text-xs">
            {data.length > 0 ? (
              data.map((s, ind) => (
                <tr
                  key={s.id}
                  className="border-t hover:bg-gray-50 text-gray-800 font-medium [&_td]:p-3"
                >
                  <td>{ind+1}</td>
                  <td>
                    <p className="w-[7rem]">{s.name}</p>
                    <p className="text-xs text-gray-400 font-normal">
                      #SITE ID-{s.id}
                    </p>
                  </td>
                  <td>{formatDate(s.lastVisit)}</td>
                  <td className="text-[10px]">
                    {s.daysSinceLastVisit > 30 ? (
                      <span
                        className={`px-[6px] py-[4px] inline-flex items-center rounded-full font-figtreeMedium bg-red-100 text-red-600`}
                      >
                        <Dot strokeWidth={6} className="w-4 h-4" />
                        {s.daysSinceLastVisit} Days
                      </span>
                    ) : (
                      <span>{s.daysSinceLastVisit} Days</span>
                    )}
                  </td>

                  <td>
                    {s.jbccTechnicianName}
                    <br></br>
                    <span
                      className={`text-gray-400 text-[10px] flex gap-1 items-center`}
                    >
                      <Phone size={10} />
                      {s.jbccTechnicianPhone}
                    </span>
                  </td>
                  <td>
                    {s.jbccSupervisorName}
                    <br></br>
                    <span
                      className={`text-gray-400 text-[10px] flex gap-1 items-center`}
                    >
                      <Phone size={10} />
                      {s.jbccSupervisorPhone}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={UNVISITED_SITE_COLUMNS.length}
                  className="text-center py-6 text-gray-500"
                >
                  No sites match the current filters.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
